<template>
  <Modal :value="true" title="Territories data" maxWidth="80%" @input="$emit('close')">
    <v-text-field label="Paste table data" @paste="getPastedData" outline v-if="!pastedData" />
    <template v-else>
      <v-text-field v-model="fileName" label="Territories file name" outline :rules="requiredRules" />
      <TablePreview :value="pastedData" v-if="pastedData" />
    </template>
    <template v-slot:actions>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="(pastedData = null), $emit('close')">Cancel</v-btn>
      <v-btn flat class="hvh-btn hvh-btn--primary" :class="{ disabled: !pastedData || !fileName }" @click="$emit('input', pastedData), $emit('close')">OK</v-btn>
    </template>
  </Modal>
</template>

<script>
import { getPastedObject } from '../../../libraries/tables';
import Modal from '../modal/HvhModal.vue';
import TablePreview from '../tablePreview/HvhTablePreview';
export default {
  components: { Modal, TablePreview, },
  data() {
    return {
      pastedData: null,
      requiredRules: [
        v => !!v || 'Field is required',
      ],
      fileName: null,
    };
  },
  methods: {
    headerData() {
      return [
        { value: 'Zip' },
        { value: 'City' },
        { value: 'State' },
        { value: 'Territory ID' },
        { value: 'Territory Name' },
        { value: 'Region ID' },
        { value: 'Region Name' }
      ];
    },
    getPastedData(event) {
      event.preventDefault();
      var data = getPastedObject(event);
      if (data) {
        // @ts-ignore
        this.pastedData = {
          ...data,
          // @ts-ignore
          header: [this.headerData()],
          data: data.data.filter((_, ind) => ind < 100),
        };
      }
    },
  }
};
</script>